// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ServiceFiscalMissingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/service_fiscal/missing
 *
 * The catalog-fiscal readiness list: active services with no effective
 * LC116 code. Feeds the pre-flight check the next milestone (BR emission
 * planner) consumes before it will emit anything.
 */
import type { So_ServiceFiscalMissingRow } from './So_ServiceFiscalMissingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ServiceFiscalMissingResponseDados = So_ServiceFiscalMissingRow[];

export type So_ServiceFiscalMissingResponse = ApiResponse<So_ServiceFiscalMissingResponseDados>;

registerResponseContract('So_ServiceFiscalMissingResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_service_id:   { type: 'number',  required: true },
      so_service_name: { type: 'string',  required: true },
    },
  },
})
